import type { ParentComponent } from "../../lib/types";

const Bullet: ParentComponent = ({ children }) => (
	<ul className="list-disc pl-6 font-serif text-sm leading-[1.6] text-foreground not-last:mb-[0.5lh] desktop:pl-8 desktop:text-md">
		{children}
	</ul>
);

export { Bullet };
